import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";
import {getApiDomain} from "../../util/domains";

/**
 * Obtiene el modelo de acuerdo al id del mismo
 * @param commit
 * @param state
 * @param requestParameters
 * @returns {Promise<void>}
 */
export async function  pdfCertificateRetention({state,commit},type) {
  state.params.type = type;
  var response = await $http.get('/api/pdfCertificadoRetencion',
    {
        params:state.params,
     // responseType: "blob"
    }
    )

    console.log('RUTAAAA',response.data );
    commit('setPathPdf',response.data);
    // const url = window.URL.createObjectURL(new Blob([response.data]));
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", "cartera.pdf"); //or any other extension
    // document.body.appendChild(link);
    // link.click();
}



// WEBPACK FOOTER //
// ./src/modules/certificates-retentions/actions.js